import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class MarketPreferencesClient {
  static baseUrl = BASE_URL;

  static getReservationReleaseStatus() {
    const url = `${this.baseUrl}/preferences/release-status`;

    return axios
      .get(url, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveReservationReleasePreferences(user, data) {
    const url = `${this.baseUrl}/preferences/reservation-release/save`;
    return axios
      .put(url, data, getHeaders())
      .then(() => Promise.resolve())
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getAldCupidId() {
    const url = `${this.baseUrl}/preferences/ald-cupid-id`;

    return axios
      .get(url, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getPaymentThreshold() {
    const url = `${this.baseUrl}/preferences/paymentThreshold`;

    return axios
      .get(url, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveCupidIdPreferences(user, data) {
    const url = `${this.baseUrl}/preferences/ald-cupid-id/save`;
    return axios
      .put(url, data, getHeaders())
      .then(() => Promise.resolve())
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static savePaymentThresholdPreferences(user, data) {
    const url = `${this.baseUrl}/preferences/paymentThreshold/save`;
    return axios
      .post(url, data, getHeaders())
      .then(() => Promise.resolve())
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getConversionRate() {
    const url = `${this.baseUrl}/conversions/marketConversionRate`;

    return axios
      .get(url, getHeaders())
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveConversionRatePreferences(user, data) {
    const url = `${this.baseUrl}/conversions/marketConversionRate/save`;
    return axios
      .post(url, data, getHeaders())
      .then(() => Promise.resolve())
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
